
/*
 * Change Password Ctrt
 *
 */
module.controller('changePasswordCtrl', ['$scope', '$state', '$http', 'baseURI', 'Transform', 'OVERLAY',
  function ($scope, $state, $http, baseURI, Transform, OVERLAY){
    var changePasswordURL = baseURI + 'cardholder/changepassword';
    $scope.passError = false;
    $scope.overlay = OVERLAY['member.home.profile/password'];
    $scope.formData = {};
    $scope.attempted = false;
    $scope.alert = {};

    $scope.attemptSubmission = function (formData){
      if(formData.$valid){
        changePassword();
      } else {
        $scope.attempted = true;
      }
    };

    var changePassword = function(){
      $scope.loading = true;

      var passwordReq = {
        Password: $scope.formData.Password,
        NewPassword: $scope.formData.NewPassword
      };

      $http({
        method: 'PUT',
        url: changePasswordURL,
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(passwordReq)
      }).then(function (resp){
        var data = resp.data;

        $scope.loading = false;
        if(data.Success){
          $scope.alert.successShown = true;
          $scope.alert.successMessage = 'You\'ve updated your password';
          $state.go('member.home.profile/password.confirmation');
        } else {
          $scope.passError = true;
        }
      }).catch(function (error){
        $scope.loading = false;
        $scope.passError = true;
      });
    };
  }]);
